<template>
	<div class="tab" data-name="educationInfo" data-type="table">
		<h3>فرم مقطع تحصیلی</h3>
		<p>[ این فرم مربوط به سوابق تحصیلی و مدارک دانشگاهی شما می باشد]</p>
		<table class="table table-bordered">
			<thead>
				<tr>
					<td>مقطع تحصیلی</td>
					<td>رشته/گرایش</td>
					<td>نام دانشگاه یا موسسه</td>
					<td>تاریخ اخذ مدرک</td>
					<td>محل اخذ مدرک</td>
					<td>معدل</td>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="name" value="سیکل" disabled />


					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="field" />
					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="university" />
					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="dateOfEvidence" />
					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="placeOfEvidence" />
					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="average" />
					</td>
				</tr>
				<tr>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="name" value="دیپلم" disabled />

					</td>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="field" />
					</td>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="university" />
					</td>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="dateOfEvidence" />
					</td>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="placeOfEvidence" />
					</td>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="average" />
					</td>
				</tr>
				<tr>
					<td data-name="name">
						<input type="text" data-row="2" class="form-control" data-name="name" value="فوق دیپلم" disabled />
					</td>
					<td>
						<input type="text" data-row="2" class="form-control" data-name="field" />
					</td>
					<td>
						<input type="text" data-row="2" class="form-control" data-name="university" />
					</td>
					<td>
						<input type="text" data-row="2" class="form-control" data-name="dateOfEvidence" />
					</td>
					<td>
						<input type="text" data-row="2" class="form-control" data-name="placeOfEvidence" />
					</td>
					<td>
						<input type="text" data-row="2" class="form-control" data-name="average" />
					</td>
				</tr>
				<tr>
					<td data-name="name">
						<input type="text" data-row="3" class="form-control" data-name="name" value="لیسانس" disabled />

					</td>
					<td>
						<input type="text" data-row="3" class="form-control" data-name="field" />
					</td>
					<td>
						<input type="text" data-row="3" class="form-control" data-name="university" />
					</td>
					<td>
						<input type="text" data-row="3" class="form-control" data-name="dateOfEvidence" />
					</td>
					<td>
						<input type="text" data-row="3" class="form-control" data-name="placeOfEvidence" />
					</td>
					<td>
						<input type="text" data-row="3" class="form-control" data-name="average" />
					</td>
				</tr>
				<tr>
					<td>
						<input type="text" data-row="4" class="form-control" data-name="name" value="فوق لیسانس" disabled />

					</td>
					<td>
						<input type="text" data-row="4" class="form-control" data-name="field" />
					</td>
					<td>
						<input type="text" data-row="4" class="form-control" data-name="university" />
					</td>
					<td>
						<input type="text" data-row="4" class="form-control" data-name="dateOfEvidence" />
					</td>
					<td>
						<input type="text" data-row="4" class="form-control" data-name="placeOfEvidence" />
					</td>
					<td>
						<input type="text" data-row="4" class="form-control" data-name="average" />
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
	export default {
		emits: ["change"],
		props: {
			init: {
				type: Function,
			},
			contract: {
				type: Object,
			},
		},
		mounted()
		{
			this.init();
		},

		change(e)
		{
			this.$emit("change", e.target);
		},
	};
</script>
<style scoped>
	input[disabled] {
		background-color: unset;
	}
</style>
